// extracted by mini-css-extract-plugin
export var alumni = "AlumniSection-module--alumni--06198";
export var content = "AlumniSection-module--content--f9433";
export var contentWrapper = "AlumniSection-module--contentWrapper--a2435";
export var img = "AlumniSection-module--img--bd7b8";
export var media = "AlumniSection-module--media--7e296";
export var mediaAvatar = "AlumniSection-module--mediaAvatar--55287";
export var title = "AlumniSection-module--title--e4bcc";
export var wrapper = "AlumniSection-module--wrapper--8f022";